import React from 'react';
import { CoachIcon } from '../svg/CoachIcon';
import { GamerIcon } from '../svg/GamerIcon';

type Props = {
    className?: string;
};

export const ScholarDescription: React.FC<Props> = ({ className }) => {
    return (
        <div className="scholar-main">
            <div className="container slim">
                <div className="scholar-description">
                    <h2 className="scholar-tagline">
                        {
                            'STAY PLUGGED IN CONNECTS HIGH SCHOOL ESPORTS PLAYERS WITH OPPORTUNITIES TO ESPORTS SCHOLARSHIPS.'
                        }
                    </h2>
                    <p className="scholar-description">{`The Stay Plugged In platform is optimized to make finding esports scholarships easier. Stay Plugged In Recruiting Specialists help define what you are looking for in colleges to ensure you find an optimal match for your next step in life. With that, we match you directly with college programs that have what you are looking for. Scholarships offer a pivotal opportunity to make college more affordable and with that, we also provide other avenues to gain esports scholarships.`}</p>
                    <h2 className="scholar-tagline green">
                        {'OVER $12 MiLLION DOLLARS iN'}
                        <br />
                        {'COLLEGE ESPORTS SCHOLARSHIPS FACILITATED'}
                    </h2>
                </div>
            </div>
        </div>
    );
};
